import React from "react";

const defaultWasteData = [
  {
    type: "Plastic waste including packaging",
    current: { recycled: "", reused: "", disposed: "" },
    previous: { recycled: "", reused: "", disposed: "" },
  },
  {
    type: "E-waste",
    current: { recycled: "", reused: "", disposed: "" },
    previous: { recycled: "", reused: "", disposed: "" },
  },
  {
    type: "Hazardous waste",
    current: { recycled: "", reused: "", disposed: "" },
    previous: { recycled: "", reused: "", disposed: "" },
  },
  {
    type: "Other waste",
    current: { recycled: "", reused: "", disposed: "" },
    previous: { recycled: "", reused: "", disposed: "" },
  },
];

const WasteManagementTable = ({ wastedata, setWasteData }) => {
  const handleChange = (index, section, field, value) => {
    const updated = [...wastedata];
    updated[index][section][field] = value;
    setWasteData(updated);
  };

  return (
    <div
      style={{
        overflowX: "auto",
        marginTop: "20px",
        border: "1px solid #000",
        overflow: "hidden",
        borderRadius: "8px",
      }}
    >
      <table
        style={{
          width: "100%",
          borderCollapse: "collapse",
        }}
      >
        <thead>
          <tr style={{ backgroundColor: "#D3C9CE", fontWeight: "bold" }}>
            <th rowSpan="2" style={tableHeaderStyle}>
              Type of Waste
            </th>
            <th colSpan="3" style={tableHeaderStyle}>
              Current FY
            </th>
            <th colSpan="3" style={tableHeaderStyle}>
              Previous FY
            </th>
          </tr>
          <tr style={{ backgroundColor: "#D3C9CE", fontWeight: "bold" }}>
            <th style={tableHeaderStyle}>
              Recycled
              <br />
              (metric tons)
            </th>
            <th style={tableHeaderStyle}>
              Reused
              <br />
              (metric tons)
            </th>
            <th style={tableHeaderStyle}>
              Safely Disposed
              <br />
              (metric tons)
            </th>
            <th style={tableHeaderStyle}>
              Recycled
              <br />
              (metric tons)
            </th>
            <th style={tableHeaderStyle}>
              Reused
              <br />
              (metric tons)
            </th>
            <th style={tableHeaderStyle}>
              Safely Disposed
              <br />
              (metric tons)
            </th>
          </tr>
        </thead>
        <tbody>
          {wastedata.map((row, idx) => (
            <tr key={idx}>
              <td style={{ ...cellStyle, fontWeight: "bold" }}>{row.type}</td>

              {/* Current FY */}
              <td style={cellStyle}>
                <input
                  type="text"
                  placeholder="Provide Details"
                  value={row.current.recycled}
                  onChange={(e) =>
                    handleChange(idx, "current", "recycled", e.target.value)
                  }
                  style={inputStyle}
                />
              </td>
              <td style={cellStyle}>
                <input
                  type="text"
                  placeholder="Provide Details"
                  value={row.current.reused}
                  onChange={(e) =>
                    handleChange(idx, "current", "reused", e.target.value)
                  }
                  style={inputStyle}
                />
              </td>
              <td style={cellStyle}>
                <input
                  type="text"
                  placeholder="Provide Details"
                  value={row.current.disposed}
                  onChange={(e) =>
                    handleChange(idx, "current", "disposed", e.target.value)
                  }
                  style={inputStyle}
                />
              </td>

              {/* Previous FY */}
              <td style={cellStyle}>
                <input
                  type="text"
                  placeholder="Provide Details"
                  value={row.previous.recycled}
                  onChange={(e) =>
                    handleChange(idx, "previous", "recycled", e.target.value)
                  }
                  style={inputStyle}
                />
              </td>
              <td style={cellStyle}>
                <input
                  type="text"
                  placeholder="Provide Details"
                  value={row.previous.reused}
                  onChange={(e) =>
                    handleChange(idx, "previous", "reused", e.target.value)
                  }
                  style={inputStyle}
                />
              </td>
              <td style={cellStyle}>
                <input
                  type="text"
                  placeholder="Provide Details"
                  value={row.previous.disposed}
                  onChange={(e) =>
                    handleChange(idx, "previous", "disposed", e.target.value)
                  }
                  style={inputStyle}
                />
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

// Styles
const tableHeaderStyle = {
  padding: "10px",
  border: "1px solid #000",
  textAlign: "center",
};

const cellStyle = {
  padding: "16px", // more vertical space
  border: "1px solid #000",
  textAlign: "center",
  verticalAlign: "middle", // center align text vertically
};

const inputStyle = {
  width: "100%",
  padding: "10px", // increased vertical padding
  minHeight: "48px", // taller input box
  borderRadius: "4px",
  border: "1px solid grey",
  fontSize: "14px",
  backgroundColor: "white",
  textAlign: "center",
  outline: "none",
};

export default WasteManagementTable;
